import { theme } from '@theme';
import styled from 'styled-components';

export const SearchWrapperContainer = styled.div`
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.3);
  border: 1px solid ${theme.palette.toolTipBackground};
  color: ${theme.palette.wetAsphalt};
  background: ${theme.palette.text.white};

  p {
    color: ${theme.palette.grey};
    font-size: ${theme.typography.fontSize}px;
    font-weight: ${theme.typography.fontWeights.semibold};
    &:last-of-type {
      margin-bottom: 0;
    }
  }

  a {
    color: ${theme.palette.blue};
  }
`;

export const WrapperPadding = styled.div`
  padding: 20px;
`;

export const LoadingIndicator = styled.div<{ isLoadingIndicatorVisible: boolean }>`
  padding: 20px;

  ${(props) =>
    props.isLoadingIndicatorVisible
      ? `
        text-align: center;

        .loading {
          line-height: 106px;
          margin-bottom: 0;

          [src*='svg'] {
            width: 28px;
            vertical-align: sub;
            margin-right: 4px;
          }
        }
        `
      : ''}
`;

export const SearchHistory = styled.div`
  h1 {
    color: ${theme.palette.grey};
    font-size: ${theme.typography.fontSize}px;
    font-weight: ${theme.typography.fontWeights.semibold};
    margin: 0 0 10px;
  }

  ul {
    li {
      color: ${theme.palette.wetAsphalt};
      padding: 2px 0;
      cursor: pointer;
    }
  }
`;

export const Actions = styled.div`
  font-size: ${theme.typography.h6}px;
  border-top: 1px solid ${theme.palette.dusty};
  padding-top: 8px;

  a {
    display: block;

    &:hover {
      text-decoration: none;
    }
`;
